import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { Card, CardContent } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Loader2, CheckCircle, XCircle, Mail } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const UnsubscribePage = () => {
  const { token } = useParams();
  const [status, setStatus] = useState('loading'); // loading, success, error
  const [message, setMessage] = useState('');

  useEffect(() => {
    const unsubscribe = async () => {
      try {
        const response = await fetch(`${API_URL}/api/nurture/unsubscribe/${token}`);
        const data = await response.json();
        
        if (response.ok && data.success) {
          setStatus('success');
          setMessage(data.message || 'You have been unsubscribed from reminder emails.');
        } else {
          setStatus('error');
          setMessage(data.detail || 'Unable to process your request.');
        }
      } catch (err) {
        setStatus('error');
        setMessage('Something went wrong. Please try again later.');
      }
    };

    if (token) {
      unsubscribe();
    }
  }, [token]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-stone-50 to-stone-100 flex items-center justify-center pt-24 px-4">
      <Card className="max-w-md w-full border-none shadow-xl">
        <CardContent className="pt-8 pb-8 text-center">
          {status === 'loading' && (
            <>
              <Loader2 className="w-16 h-16 animate-spin text-[#8CB89F] mx-auto mb-4" />
              <h2 className="text-xl font-semibold text-stone-800 mb-2">Processing...</h2>
              <p className="text-stone-600">Please wait while we update your preferences.</p>
            </>
          )}
          
          {status === 'success' && (
            <>
              <CheckCircle className="w-16 h-16 text-green-500 mx-auto mb-4" />
              <h2 className="text-xl font-semibold text-stone-800 mb-2">Unsubscribed</h2>
              <p className="text-stone-600 mb-6">{message}</p>
              <p className="text-sm text-stone-500 mb-6">
                You won't receive any more reminder emails about your quote. 
                If you change your mind, you can still access your quote directly.
              </p>
              <Link to="/">
                <Button className="bg-[#8CB89F] hover:bg-[#7aa88d] text-white">
                  Return to Homepage
                </Button>
              </Link>
            </>
          )}
          
          {status === 'error' && (
            <>
              <XCircle className="w-16 h-16 text-red-500 mx-auto mb-4" />
              <h2 className="text-xl font-semibold text-stone-800 mb-2">Oops!</h2>
              <p className="text-stone-600 mb-6">{message}</p>
              <Link to="/contact">
                <Button variant="outline">
                  Contact Us
                </Button>
              </Link>
            </>
          )}
          
          {/* Footer note */}
          <div className="mt-8 pt-6 border-t border-stone-200">
            <div className="flex items-center justify-center gap-2 text-stone-500 text-sm">
              <Mail className="w-4 h-4" />
              <span>Aston Lily Shutters</span>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default UnsubscribePage;
